<template>
    <div class="__l">
        <h1 class="title">Publications</h1>
        <div class="actions right text-right">
            <button class="btn-primary" type="button" @click="IPList">Review IPs</button>
        </div>
        <input type="text" v-model="search" class="form-field py-4 px-6" ref="searchbar"
               placeholder="Search for Publications" @keyup.enter="handleSearch">
        <div v-if="results.data && search">
            <p>The total number of results for <strong>"{{ search }}"</strong> is <strong>{{ results.total }}</strong>
            </p>
        </div>
        <div v-if="results.data && !search">
            <p>The total number of results is <strong>{{ results.total }}</strong></p>
        </div>
        <div class="results-list">
            <div class="results-row">
                <div class="results-head" data-width="10%">ID</div>
                <div class="results-head" data-width="40%">Title</div>
                <div class="results-head" data-width="10%">Readership</div>
                <div class="results-head" data-width="20%">Readership Source</div>
                <div class="results-head" data-width="20%">Media Type</div>
            </div>
            <template v-if="results.data">
                <div class="results-row" v-for="(result, index) in results.data" :key="index"
                     @click="handleSelectPublication(result)">
                    <div class="results-cell" data-width="10%">{{ result.id }}</div>
                    <div class="results-cell" data-width="40%">{{ result.title }}</div>
                    <div class="results-cell" data-width="10%">{{ result.readership }}</div>
                    <div class="results-cell" data-width="20%">{{ result.readership_source }}</div>
                    <div class="results-cell" data-width="20%">{{ result.type }}</div>
                </div>
                <pagination v-model="page" :records="results.total" :per-page="25" @paginate="loadData"
                            v-if="results.data"></pagination>
            </template>
            <div class="results-row" v-if="!results.data">
                <div class="results-span text-center" data-width="100%">
                    <p>No results found</p>
                </div>
            </div>
        </div>
        <router-view v-slot="{ Component }">
            <transition name="drop-in" mode="in-out">
                <component :is="Component"></component>
            </transition>
        </router-view>
    </div>
</template>

<script>
import Pagination from 'v-pagination-3'

export default {
    name: 'Publications',
    data() {
        return {
            search: null,
            results: {},
            page: 1,
        }
    },
    components: {
        Pagination
    },
    mounted() {
        this.setMetaTitle('List Publications | JournoLink Control')
        this.loadData()
    },
    methods: {
        handleSearch() {
            this.loadData()
        },
        /**
         * Load the results from the data provider
         *
         * @return {void}
         */
        loadData() {
            axios.get(route('publications.list'), {
                params: {
                    term: this.search,
                    page: this.page,
                },
            })
                .then(response => {
                    this.results = response.data.results
                })
                .catch(e => {
                    console.error({e})
                    this.$bus.$emit('alert.danger', 'There was an error retrieving publications')
                })
        },
        /**
         * Handle the selection of a publication
         *
         * @param  {Object} publication
         * @return {void}
         */
        handleSelectPublication(publication) {
            this.$router.push({
                name: 'publications.show', params: {
                    publicationId: publication.id
                }
            })
        },
        /**
         * Open IP List
         */
        IPList() {
            this.$router.push({name: 'publications.ip.list'})
        }
    },
    beforeRouteUpdate(to, from, next) {
        if (to && to.name === 'publications.list') {
            this.setMetaTitle('List Publications | JournoLink Control')
            this.loadData()
        }

        next()
    },
}
</script>

<style lang="less">
</style>
